import { debounce } from "@mui/material";
import React, { useEffect, useRef } from "react";
import SaitTextField from "./SaitTextField";

export default function SaitDebouncedTextField(props) {
	const { value, onChange, onEnter, inputRef, ...textfieldProps } = props;
	const textFieldRef = inputRef || useRef(null);
	const debounceTime = 200;
	const handleChangeValue = (e) => {
		if (textFieldRef.current) {
			textFieldRef.current["value"] = e.target.value;
		}
		debouncedHandleChangeValue(e);
	};

	const debouncedHandleChangeValue = debounce((newValue) => {
		onChange(newValue);
	}, debounceTime);

	useEffect(() => {
		if (textFieldRef.current) {
			if (textFieldRef.current["value"] !== value) {
				textFieldRef.current["value"] = value;
			}
		}
	}, [value]);

	return (
		<SaitTextField
			{...textfieldProps}
			inputRef={textFieldRef}
			onChange={(e) => {
				handleChangeValue(e);
			}}
		/>
	);
}
